module.exports = __webpack_public_path__ + "img/issue-icon5.93fc578.png";